<template>
  	<div class="stores">
    	<div class="breadcrumb">教练列表</div>
	    <div class="searchBtn">
			<el-button size='small' type="primary" icon="el-icon-plus" @click="add" plain v-has="'coach_list_add'">新建</el-button>
	    </div>
    	<template>
        	<el-table border ref="multipleTable" :data="tableData" style="width: 100%" @current-change="handleCurrentChange" header-cell-class-name="table-header">
		        <el-table-column prop="id" label="ID"></el-table-column>
		        <el-table-column prop="coachName" label="名字" show-overflow-tooltip></el-table-column>
		        <!-- <el-table-column prop="mobile" label="手机号码" show-overflow-tooltip>
					<template slot-scope="scope">
		            	<span>{{scope.row.mobile?scope.row.mobile.substring(0,3)+'****'+scope.row.mobile.substring(scope.row.mobile.length-4):''}}</span>
		            </template>
				</el-table-column> -->
		        <el-table-column prop="sex" label="性别" show-overflow-tooltip>
		        	<template slot-scope="scope">
		            	{{scope.row.sex==0?'男':scope.row.sex==1?'女':'未知'}}
		            </template>
		        </el-table-column>
		        <el-table-column prop="age" label="年龄" show-overflow-tooltip></el-table-column>
		        <el-table-column prop="city" label="城市" show-overflow-tooltip></el-table-column>
		        <el-table-column prop="coachAvatar" label="头像">
		            <template slot-scope="scope">
		            	<div class="imgWidth">
		            		<img :src="scope.row.coachAvatar"  />
		            	</div>
		            </template>
	          	</el-table-column>
	          	<el-table-column prop="createTime" :formatter="dateFormat" label="创建时间"></el-table-column>
				<el-table-column label="操作" width="140" align="center">
					<template slot-scope="scope">
						<el-button v-has="'course_type_update'"
								@click="edit(scope.row.id)"
								type="text"
								size="small"
								icon="el-icon-s-order">编辑</el-button>
						<el-popconfirm title="确定删除吗？" @confirm="del(scope.row.id)">
							<el-button v-has="'course_type_delete'"
								slot="reference"
								type="text"
								size="small"
								style="color:red;"
								icon="el-icon-delete">删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
	        </el-table>
      	</template>

      	<div class="block" style="padding:30px 10px; float:right">
        	<el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
      	</div>

    	<!-- 添加修改教练弹框 -->
    	<el-dialog title="提示" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
      		<el-form :model="ruleForm" ref="ruleForm" :rules="ruleForms" status-icon label-width="130px">
				<el-form-item label="教练名称" prop="coachName" class="selectUser">
					<el-input v-model="ruleForm.coachName" placeholder="请输入教练名称" style="width: 80%;"></el-input> 
		        </el-form-item> 
		        <el-form-item label="手机号" prop="mobile" class="selectUser">
					<el-input v-model="ruleForm.mobile" placeholder="请输入手机号" style="width: 80%;"></el-input> 
		        </el-form-item> 
				<el-form-item label="城市" prop="city">
		          	<el-input v-model="ruleForm.city" placeholder="请输入城市名称" style="width: 80%;"></el-input>
		        </el-form-item>
				<el-form-item label="性别" prop="sex">
					<el-radio-group v-model="ruleForm.sex">
                        <el-radio label="0" >男</el-radio>
                        <el-radio label="1" >女</el-radio>
                        <el-radio label="-1" >未知</el-radio>
                    </el-radio-group>
		        </el-form-item>
		        <el-form-item label="年龄" prop="age">
					<el-input-number :precision="0" :min="1" :max="150" size="medium" v-model="ruleForm.age"></el-input-number>
		        </el-form-item>
				<el-form-item label="体重(kg)" prop="weight">
					<el-input-number :precision="0" :min="1" :max="300" size="medium" v-model="ruleForm.weight"></el-input-number>
		        </el-form-item>
				<el-form-item label="身高(cm)" prop="height">
					<el-input-number :precision="0" :min="1" :max="300" size="medium" v-model="ruleForm.height"></el-input-number>
		        </el-form-item>
				<el-form-item label="教练教授课程" prop="coachKinds">
					<el-checkbox-group v-model="courseKindList" @change="ruleForm.coachKinds=courseKindList.join(',')">
                        <el-checkbox :label="item.id" v-for="item in coachKindList" :key="item.id">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
					<el-input v-model="ruleForm.coachKinds" type="hidden"></el-input>
				</el-form-item>
				<el-form-item label="上传头像" prop="coachAvatar">
		          	<el-input v-model="ruleForm.coachAvatar" placeholder style="width: 80%;"></el-input>
					<img-upload :img-url.sync="ruleForm.coachAvatar"></img-upload>
					<p style="font-size:12px;color:red;">图片规格：100px*100px,格式：png、jpg</p>
		        </el-form-item>
				 <el-form-item label="上传教练半身图" prop="halfLengthPhoto">
		          	<el-input v-model="ruleForm.halfLengthPhoto" placeholder style="width: 80%;"></el-input>
					<img-upload :img-url.sync="ruleForm.halfLengthPhoto"></img-upload>
					<p style="font-size:12px;color:red;">图片规格：248px*348px,格式：透明png</p>
		        </el-form-item>
		        <el-form-item label="上传教练封面图" prop="coachPhoto">
		          	<el-input v-model="ruleForm.coachPhoto" placeholder style="width: 80%;"></el-input> 
					<img-upload :img-url.sync="ruleForm.coachPhoto"></img-upload>
					<p style="font-size:12px;color:red;">图片规格：750px*846px,格式：png、jpg</p>
		        </el-form-item>

		        <el-form-item label="教练描述" prop="coachDesc">
		          	<el-input type="textarea" v-model="ruleForm.coachDesc" placeholder="请输入教练描述" style="width:80%" :rows="5"></el-input>
		        </el-form-item>
		        <el-form-item label="教练奖项" prop="coachAwards">
		          	<el-input type="textarea" v-model="ruleForm.coachAwards" placeholder="请输入教练奖项" style="width:80%" :rows="5"></el-input>
		        </el-form-item>
		        <el-form-item label="教练教授课程描述" prop="coachKindDesc">
		          	<el-input type="textarea" v-model="ruleForm.coachKindDesc" placeholder="请输入教练教授课程描述" style="width:80%" :rows="5"></el-input>
		        </el-form-item>
      		</el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible = false">取 消</el-button>
		        <el-button type="primary" @click="onSubmit()">确 定</el-button>
		    </span>
    	</el-dialog>
    	<!-- 请选择用户 -->
    	<el-dialog title="提示" :visible.sync="dialogVisible2" width="35%" :before-close="handleClose2">
      		<el-scrollbar style="height:500px; width:100%;">
		        <template>
		          	<el-table ref="multipleTable" :data="usersData" highlight-current-row tooltip-effect="dark" style="width: 100%" @current-change="handleCurrentChange2">
		            	<el-table-column prop="id" align="center" label="ID"></el-table-column>
		            	<el-table-column prop="mobile" align="center" label="手机号" show-overflow-tooltip></el-table-column>
		            	<el-table-column prop="nickname" align="center" label="昵称" show-overflow-tooltip></el-table-column>
		          	</el-table>
		        </template>
	        	<div class="block" style="padding:30px 10px; float:right" @click.stop>
	          		<el-pagination @current-change="handleCurrentChangePage2" :current-page="pageNum2" :page-size="limit2" layout="total, prev, pager, next, jumper" :total="totalPage2"></el-pagination>
	        	</div>
      		</el-scrollbar>
    	</el-dialog>
  	</div>
</template>

<script> 
import ImgUpload from '@/components/ImgUpload';
export default {
  	components: {ImgUpload},
  	mounted() {
  		this.sportsKind();
    	this.getList()
  	},
  	data() {
    	return {
	       	searchForm: {// 搜索参数
	        	pageNum: 1,
	        	limit: 10,
	      	},
      		isUserId: true, //判断添加修改状态下，选择教练是否点击
      		headers: {
        		xqiao_token: localStorage.getItem("token") 
      		},
      		tableData2: [], //选择门店
      		tableData: [],
      		courseKindList: [],
      		pageNum: 1,
      		limit: 10,
      		totalPage: 10,
      		pageNum2: 1,
      		limit2: 10,
      		totalPage2: 100,
      		usersData: [], //选择教练
      		currentRow: "",
      		ruleForm: {
		        city: "", //城市
		        coachAvatar: "", //教练头像
				coachAwards:"",//教练奖项
				coachDesc:"",//教练描述
		        halfLengthPhoto:'',//教练半身图
		        userId: "", //教练ID
				coachKinds:'',//教练教授课程
				coachKindDesc:'',//教练教授课程描述
				mobile:"",//教练手机
				coachPhoto:"",//教练封面
				coachName:"",//教练封面
				weight:"",//体重
				height:"",//身高
		        age: "",
		        sex: 0,
      		},
      		ruleForms: {
		        coachName: [{ required: true, message: "请输入教练名称"}],
		        weight: [{ required: true, message: "请输入教练体重"}],
		        height: [{ required: true, message: "请输入教练身高"}],
		        sex: [{ required: true, message: "请选择性别",trigger: "change" }],
		        age: [{ required: true, message: "请输入年龄",trigger: "change" }],
				city: [{ required: true, message: "请选择城市",trigger: "blur" }],
		        coachAvatar: [{ required: true, message: "请上传头像", trigger: "blur" }],
		        mobile: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
		        coachDesc:[{ required: true, message: "请输入教练描述", trigger: "blur" }],
		        coachKinds:[{ required: true, message: "请选择教练教授课程"}],
		        halfLengthPhoto: [{ required: true, message: "请上传教练半身图", trigger: "blur" }],
		        coachPhoto: [{ required: true, message: "请上传教练封面", trigger: "blur" }],
      		},
	      	dialogVisible: false,
	      	dialogVisible2: false,
	      	isShow: false,
	      	tmpFiles: process.env.API_ROOT + "/tmpFiles",
	      	coachKindList:[]
	      	// off: false,
    	};
  	},
  	methods: { 
		SkipProgress(e){
			if (e.target.tagName === 'INPUT') return;
		},
    	getList() { //获取列表
      		let params = this.searchForm;
      		this.$get("/coaches", params)
	        .then(res => {
	        	console.log(res)
	          	if (res.code == 0) {
		            this.tableData = res.data.list;
		            this.totalPage = res.data.total;
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
		            return false;
	          	}
	        })
	        .catch(() => {
	          	console.log();
	        });
    	},
    	//时间格式化
	    dateFormat: function(row, column) {
	      	var date = row[column.property];
	      	if (date == undefined) {
	        	return "";
	      	}
	      	return this.$moment(date).format("YYYY-MM-DD HH:mm:ss");
	    },
	    rulestoresId(val){//修改门店
	    	this.ruleForm.storeId=val
	    },
    	onEditeClick(row){//编辑
      		console.log(row)
    	},
    	onDelClick(row){//删除
	      	this.del(row.id)
    	},
    	onRowDBClick (row) { // 双击列表
     		console.log(row)
    	}, 
    	onPageChange (page) { // 改变页数
	      	this.searchForm.pageNum = page
	      	this.getList()
    	},
    	//当前页数
	    handleCurrentChangePage(val) {
	    	this.searchForm.pageNum = val;
	      	this.getList()
	    },
	    //当前页数
	    handleCurrentChangePage2(val) {
	      	this.pageNum2 = val;
	      	this.userList();
	    },
	    //弹框关闭按钮
	    handleClose(done) {
	      	if (this.$refs.ruleForm != undefined) {
	        	this.$refs.ruleForm.resetFields();
	        	this.ruleForm={
			        city: "", //城市
			        coachAvatar: "", //教练头像
			        storeId: "", //门店ID
			        coachId: "", //教练ID
			        userId: "", //用户ID
			        age: "0",
			        sex: "0",
			        nickName: "点击选择用户"
		      	}
	      	}
	      	done();
	    },
	    //
	    handleClose2() {
	      this.dialogVisible2 = false;
	    },
	    //
	    selUserDialog() {
	      	this.dialogVisible2 = true;
	    },

	    //选择需要修改的权限
	    handleCurrentChange(val) {
	      	if (val) {
	        	this.currentRow = val.id;
	      	}
	    },
	    //点击选择用户行
	    handleCurrentChange2(val) {
	    	console.log(val);
	      	this.dialogVisible2 = false;
	      	if (val) {
	        	this.ruleForm.age = val.age;
	        	this.ruleForm.sex = val.sex;
	        	this.ruleForm.userId = val.id;
	        	this.ruleForm.nickName = val.nickname;
	      	}
	    },
	    //选择门店
	    selectStores() {
	      	var params = {
	        	pageNum: 1,
	        	limit: 20
	      	};
	      	this.$get("/stores", params)
	        .then(res => {
	        	console.log(res)
	          	if (res.code == 0) {
	            	this.tableData2 = res.data.list;
	          	} else {
	            	this.$message({
	              		message: res.message,
	              		type: "warning"
	            	});
	            	return false;
	          	}
	        })
	        .catch(() => {
	          	console.log();
	        });
	    },
	    sportsKind(){
	    	this.$get("/course/sportsKind")
	        .then(res => {
	        	console.log(res)
	          	if (res.code == 0) {
	            	this.coachKindList = res.data;
	          	} else {
	            	this.$message({
	              		message: res.message,
	              		type: "warning"
	            	});
	            	return false;
	          	}
	        })
	    },
	    //选择用户
	    userList() {
	      	var params = {
		        pageNum: this.pageNum2,
		        limit: this.limit2
	      	};
	      	this.$get("/users", params)
	        .then(res => {
	          	if (res.code == 0) {
	            	this.usersData = res.data.list;
	            	this.totalPage2 = res.data.total;
	          	} else {
	            	this.$message({
	              		message: res.message,
	              		type: "warning"
	            	});
	            	return false;
	          	}
	        })
	        .catch(() => {
	          	console.log();
	        });
	    },
    	//添加
    	add() {
	      	if (this.$refs["ruleForm"]) {
	        	this.$refs["ruleForm"].resetFields();
	      	}
			for(let i in this.ruleForm){
				this.ruleForm[i]='';
			}
			this.ruleForm.sex="0"
			this.courseKindList=[]
	      	this.dialogVisible = true;
	    },
    	onSubmit() {
			this.$refs.ruleForm.validate(valid => {
				if (valid) {
					this.loading = true;
					const method=this.ruleForm.userId?this.$put:this.$post;
					const url=this.ruleForm.userId?"/coaches/" + this.ruleForm.userId:"/coaches";
					method(url,this.ruleForm)
					.then(res => {
						if (res.code == 0) {
							this.$message.success('操作成功');
							this.pageNum = 1;
							this.getList();
							this.dialogVisible = false;
						} else {
							this.$message.error(res.message);
						}
						this.loading = false;
					})
					.catch(() => {
						this.loading = false;
					});
				} else {
					return this.$message.error('有必填项目未填写');;
				}
			});
    	},
    	select_status(){
    		this.$forceUpdate();
    	},
	    edit(currentRowId) {
	      	this.userList();
	      	this.$get("/coaches/" + currentRowId)
	          	.then(res => {
		            if (res.code == 0) { 
						this.courseKindList=this.$_.isString(res.data.coachKinds)?(Array.isArray(res.data.coachKinds.split(','))?res.data.coachKinds.split(','):[]):[];
						this.ruleForm ={
							city: res.data.city, //城市
							coachAvatar: res.data.coachAvatar, //教练头像
							coachAwards:res.data.coachAwards,//教练奖项
							coachDesc:res.data.coachDesc,//教练描述
							halfLengthPhoto:res.data.halfLengthPhoto,//教练半身图
							userId: res.data.id, //教练ID
							coachKinds:res.data.coachKinds,//教练教授课程
							coachKindDesc:res.data.coachKindDesc,//教练教授课程描述
							mobile:res.data.mobile,//教练手机
							coachPhoto:res.data.coachPhoto,//教练封面
							age: this.$_.isNumber(Number(res.data.age))?Number(res.data.age):'',
							sex: res.data.sex+'',
							coachName:res.data.coachName, 
							height:res.data.height, 
							weight:res.data.weight
						};
		              	this.dialogVisible = true;
		            }
	          	})
	          	.catch(() => {});
	    },
	    del(currentRowId) {
	    	this.$delete("/coaches/" + currentRowId)
				.then((res)=>{
					console.log(res);
					if (res.code == 0) {
						this.$message.success('删除成功');
						this.pageNum = 1;
						this.getList();
					} else {
						this.$message.error('操作失败');
					}
				})
				.catch(function(err) {
					console.log(err);
				});
	    },

	    //选择图片成功
	    handleAvatarSuccess(res, file) {
	      	console.log(res);
	      	this.ruleForm.coachAvatar = res.data.url;
	    },
	    handleAvatarSuccess2(res, file){
	    	this.ruleForm.coachHalfLengthPhoto = res.data.url;
	    },
	    handleAvatarSuccess3(res, file){
	    	this.ruleForm.cover1 = res.data.url;
	    },
	    beforeAvatarUpload(file) {
	      	const isPng = file.type === "image/png";
	      	const isLt2M = file.size / 1024 < 25;
	      	if (!isPng) {
	        	this.$message.error("上传头像图片只能是 png 格式!");
	        	return false
	      	}
	      	if (!isLt2M) {
	        	this.$message.error("上传头像图片大小不能超过 25kb!");
	      	}
	      	return isPng && isLt2M;
	    }
  	}
};
</script>

<style scoped>
::deep
.avatar-uploader-icon {
    width: 108px;
    line-height: 108px
}
.selectUser {
  	color: #409eff;
}
.selectUser label,
.selectUser i {
  	font-size: 12px;
}
.imgWidth{
	width: 50px;
	height: 50px;
	border:1px solid #ccc;
	display:flex;
  	align-items:center;
}
.imgWidth img,.avatar{
	max-width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/views/coachesList/index.vue